var map = {
	"./3d.png": 1735,
	"./AvoMaps.png": 2155,
	"./BallingWithData.png": 2002,
	"./Gentrification_IG.png": 962,
	"./OpenCavo.png": 6132,
	"./PredictingFilmSuccess.png": 5213,
	"./Unity_IG.png": 38,
	"./bearchainAI.png": 5162,
	"./bearwear.png": 5423,
	"./bearyHungry.png": 6947,
	"./bounc.png": 9329,
	"./buildABear.png": 6571,
	"./calmemaybe.png": 1381,
	"./capital.png": 8789,
	"./chatbot.png": 7690,
	"./chicken.png": 4167,
	"./classifai.png": 6220,
	"./clients/Byte Kitchen Logo.png": 1319,
	"./clients/Cozmicgo Logo.png": 3935,
	"./clients/IBM Logo.png": 7505,
	"./clients/Kinship Logo.png": 8956,
	"./clients/Quantcast Logo.png": 4728,
	"./cody.mp3.png": 409,
	"./codythereum.png": 1879,
	"./constellation.png": 3919,
	"./discord.png": 5591,
	"./flappy.png": 4913,
	"./movies.png": 3042,
	"./music.png": 7370,
	"./personal_portfolio.png": 2523,
	"./seawarden.png": 5035,
	"./shares.png": 30,
	"./shoptimum.png": 9434,
	"./space.png": 862,
	"./spotifai.png": 555,
	"./spotify.png": 5326,
	"./vendingmachine.png": 4825,
	"./vendingmachine_square.png": 9296,
	"./vscodeology.png": 6780,
	"./www.png": 1926,
	"./zen.png": 7925,
	"./zoom.png": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1393;